import React from 'react';
import SideBar from 'components/SideBar';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import { Redirect } from 'react-router-dom';
import { isAuth } from 'store/ducks/auth';
import { routes } from 'config/routes';
import ServiceForm from '../ServiceForm';
import { Menus } from '../../config/Menu';

const LoggedComponents = ({ children }) => (
  <>
    <ServiceForm />
    <SideBar options={Menus} />
    {children}
  </>
);

const ProtectedRoute = ({ isAllowed, component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (isAllowed() ? (
      <LoggedComponents>
        <Component {...props} />
      </LoggedComponents>
    ) : (
      <Redirect
        to={{
          pathname: routes.home, // where user will be sent when disallowed
          state: { from: props.location },
        }}
      />
    ))
    }
  />
);

export default connect(state => ({
  location: state.router.location,
  isAllowed: () => isAuth(state),
}))(ProtectedRoute);
